import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.js";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import * as libUrl from "../lib/url.ts";
import * as Storage from "../lib/Storage.ts";
import { PlanningDay } from "./mealplannerApi.ts";
import * as DateUtils from "../lib/DateUtils.ts"

var renewSessionUrl;
function onApiError(error){
  let lastRenew = Storage.sessionGet("lastRenew");
  if(lastRenew==null || (new Date()-new Date(lastRenew)>30000)){
    Storage.sessionSet("lastRenew",new Date().toISOString());
    window.location = renewSessionUrl;
  }else{
    modal.alert("fw2.defaultError")
  }
  
}


INR.onPage(INR.URL.MEALPLANNER_NC,function(){
  renewSessionUrl = libLocation.getURLParam("re");
  let 
    params = libLocation.extractParam(renewSessionUrl),
    token = params.Tv || params.v;

  ApiServer.mpncshared(token,function(mealPlannerSharedBean){
    var 
      dishRangeBean = mealPlannerSharedBean.range,
      settings = mealPlannerSharedBean.settings,
      dateStart = new Date(dishRangeBean.from+'T00:00:00'),
      dateRangeEnd = new Date(new Date(dishRangeBean.to+'T00:00:00')-1000),
      days = [],
      daysByKey = {};
    
    
    var 
      dateCrawler = new Date(dishRangeBean.from+'T00:00:00');
    while(dateCrawler<dateRangeEnd){
      var planningDay = new PlanningDay(dateCrawler,settings);
      days.push(planningDay);
      daysByKey[planningDay.key] = planningDay;
      dateCrawler.setDate(dateCrawler.getDate()+1);
    }
    $('#weekdisplay').html(DateUtils.dayRangeString(new Date(dishRangeBean.from+'T00:00:00'),new Date(new Date(dishRangeBean.to+'T00:00:00')-1000)))
    
    
    dishRangeBean.list.forEach(function(dish){
      var 
        dayKey = dish.date,
        day = daysByKey[dayKey],
        slot = day.dishByType[dish.type];
      
      if(slot){
        day.dishes.push(dish)
        slot.push(dish);
      }
      
    })
    import("../mealplanner/planning.mustache").then(function(TPL){
      Html.setHtml($("#planner-pane"),TPL,{days:days,settings:settings,viaSharing:true});
    });
  },onApiError);
});

Html.register({
  ncrecipe:function(metaId){
    libLocation.goTo(libUrl.addParams("recipebox_nc.php",{re:libLocation.getURLParam("re"),metaId:metaId}))
  }
})